import CircularProgress from "components/CircularProgress/CircularProgress";
import FirstRoundLetterComp from "components/FirstRoundLetter/FirstRoundLetter";
import Status from "components/Status/Status";
import StatusWithDot from "components/StatusWithDot/StatusWithDot";
import moment from "moment-timezone";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TRUE } from "sass";
import {
  HorizontalLine,
  HorizontalLineDivider,
} from "styledComponents/Activity";

import avatar5 from "../../assets/img/avatar_5.svg";
import audioIcon from "../../assets/img/icons/Audio.svg";
import editIconWhite from "../../assets/img/icons/Edit_white.svg";
import previewIconWhite from "../../assets/img/icons/Eye-whitebg.svg";
import previewIconNormal from "../../assets/img/icons/Eye_normal.svg";
import imageIcon from "../../assets/img/icons/Image.svg";
import arrowWhiteIcon from "../../assets/img/icons/arrow_right_white.svg";
import Chat from "../../assets/img/icons/chat.svg";
import deleteIconNormal from "../../assets/img/icons/delete_normal.svg";
import deleteIconWhite from "../../assets/img/icons/delete_white.svg";
import duplicateIcon from "../../assets/img/icons/duplicate-new.svg";
import editIconNormal from "../../assets/img/icons/edit-2.svg";
import expandIconNormal from "../../assets/img/icons/expand_normal.svg";
import expandIconWhite from "../../assets/img/icons/expand_white.svg";
import eyeIcon from "../../assets/img/icons/eye.svg";
import tick from "../../assets/img/icons/tick-white-bold.svg";
import { CardText } from "../../components/DashboardCards/cardStyles";
import DropdownLoader from "../../components/DropdownLoader/DropdownLoader";
import ComponentCircleLoader from "../../components/Loaders/ComponentCircleLoader";
import NoDataComponent from "../../components/NoDataComponent/NoDataComponent";
import AssigneeTooltip from "../../components/Tooltip/AssigneeTooltip";
import CommonTooltip from "../../components/Tooltip/CommonTooltip";
import TaskActionTooltip from "../../components/Tooltip/TaskActionTooltip";
import {
  ActionSection,
  BudgetCollapseSection,
  ClientDeadlineGrid,
  ListUpperSection,
  ProjectDuplicateDiv,
  ProjectDuplicateIcon,
  ProjectItemCount,
  ProjectListItem,
  ProjectListSection,
  ProjectTableContainer,
  ProjectTableContainerNew,
  ProjectTitleDiv,
  TableItem,
  TableRowAndBudgetCollapseContainer,
} from "../../styledComponents/ProjectsNew";
import { PrimaryButton } from "../../styledComponents/buttons";
import {
  ClientLocationsTableHeaderContainer,
  ClientLocationsTableRowContainer,
  GeneralInfoItem,
  GeneralInfoSection,
  HoveredSection2,
  InnerDivTooltip,
  RoundHover,
  ToolTipContainer,
  TooltipText,
} from "../../styledComponents/clients";
import {
  AssignListText,
  ColoredText,
  CommonFlex,
  CommonFlexIcon,
  CommonImage,
  CommonText,
  Container,
  DividerLine,
  ShowMoreAssigneeList,
  TableText,
} from "../../styledComponents/common";
import {
  AssigneeRoundImage,
  AssigneeRoundImageSection,
  RoundImageCross,
  RoundPersonImage,
} from "../../styledComponents/createProject";
import { MemberNameDiv } from "../../styledComponents/members";
import {
  IntegrationIcon,
  IntegrationIconDiv,
} from "../../styledComponents/tasks";
import {
  checkHtml,
  checkUrl,
  formatTimeInTimezone,
  globalDateFormat,
} from "../../utils/helper";
import { toHHMMSS } from "../../utils/helper";
import {
  DeleteButton,
  EditButton,
} from "../FieldServices/JobSites/jobSitesStyles";
import {
  CardBlock,
  GreenCircle,
  LateTag,
} from "../FieldServices/RouteMapNew/routeMapStyles";
import { CommImageNameComp } from "../Members/CommonComponents";
import {
  ExpandIcon,
  ProjectExpandButton,
  ProjectListStatusBadge,
} from "../Projects/projectsStyles";
import { CommDropdownComp } from "../Tasks/AddAssigneeDropdown";
import EvidenceGalleryModal from "../EvidenceGallaryModal/EvidenceGalleryModal";
import {
  CallSection,
  EmployeeInfoBlock,
  EvidenceIcon,
  EvidenceIconSection,
  EvidenceThumbnail,
  LabelTextBlock,
  NoteSection,
  StatusBar,
} from "./JobApproval/taskApprovalStyle";
import JobListCollapseSection from "./JobListCollapseSection";
import {
  ActionIconSection,
  ApprovalBadge,
  AssigneeRoundImg,
  CollapseSection,
  IconButtonHolder,
  RoundIcon,
  TaskInfoSection,
  TaskStatusButton,
} from "./tasksStyles";

const isReadyToDispatchStatus = status =>
  status === "ready to dispatch" || status === "scheduled";

const JobList = ({
  selectedOrganization,
  expandedTaskId,
  setExpandedTaskId,
  // visibilityChange,
  loadingTaskAssigneeId,
  toggleDeleteModal,
  isLoading,
  jobList,
  history,
  taskStatus,
  setIsEditJobPopupOpen,
  setSelectedJob,
}) => {
  const [duplicateTooltip, setDuplicateTooltip] = useState(null);
  const role = localStorage.getItem("selected_organization_role");
  const user_id = localStorage.getItem("user_id");
  const projectBudgetAndBillableIsLoading = false;
  const [isCheckInOut, setIsCheckInOut] = useState(false);
  const [moreAssignee, setMoreAssignee] = useState(false);
  const [selectedRow, setSelectedRow] = useState(-1);

  const moreRef1 = useRef(null);
  const moreRef2 = useRef(null);
  const [visibility, setVisibility] = useState(0);
  // Evidence Gallery Modal
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryItems, setGalleryItems] = useState([]);
  const [galleryStartIndex, setGalleryStartIndex] = useState(0);

  // ToolTip
  const [selectIndex, setSelectIndex] = useState(-1);
  const [toolTip, setToolTip] = useState(-1);

  useEffect(() => {
    if (jobList && jobList.length > 0) {
      setExpandedTaskId(null);
      jobList.forEach(item => {
        const assigneesData = [...item.assignees];

        assigneesData.forEach((assignee, index) => {
          const checkedin = item.checkinout.find(
            obj => obj.event === "checkin" && obj.user === assignee.id,
          );
          const checkedout = item.checkinout.find(
            obj => obj.event === "checkout" && obj.user === assignee.id,
          );

          if (checkedin) {
            assigneesData[index].checkedin = checkedin;
          }
          if (checkedout) {
            assigneesData[index].checkedout = checkedout;
          }
          /* 
          +------------+-------------+---------------+-----------------+-------------+
          | Checked In | Checked Out | Job End Time  | Assignee Status | Results     |
          +------------+-------------+---------------+-----------------+-------------+
          | True       |             |               | False           | In Progress |
          +------------+-------------+---------------+-----------------+-------------+
          | True       | True        |               | True            | Completed   |
          +------------+-------------+---------------+-----------------+-------------+
          | False      | False       | In Range      | False           | To Do       |
          +------------+-------------+---------------+-----------------+-------------+
          | False      | False       | crossed       | false           | Missed      |
          +------------+-------------+---------------+-----------------+-------------+
    */
          if (assignee.assignee_status) {
            if (checkedin && checkedout) {
              assigneesData[index].status = "Completed";
            }
          } else {
            if (checkedin) {
              if (!checkedout) {
                assigneesData[index].status = "In Progress";
              }
            } else {
              if (
                !checkedout &&
                moment().unix() <
                  moment.utc(item.end_time).tz(orgTimezone).unix()
              ) {
                assigneesData[index].status = "To Do";
              } else {
                assigneesData[index].status = "Missed";
              }
            }
          }

          const evidencesForAssignee = (item.evidences || []).filter(
            obj => obj.created_by === assignee.id,
          );

          if (evidencesForAssignee && evidencesForAssignee.length) {
            assigneesData[index].evidences = evidencesForAssignee;
            // keep first evidence for backward compatibility
            assigneesData[index].evidence = evidencesForAssignee[0];
          }
        });
      });
    }
  }, [jobList]);

  // Collect evidences from specific assignee (supports multiple evidences)
  const collectAssigneeEvidences = (assignee) => {
    const evidences = [];
    // Get evidences array (or convert single evidence to array for backward compatibility)
    const assigneeEvidences = assignee?.evidences || (assignee?.evidence ? [assignee.evidence] : []);
    
    assigneeEvidences.forEach((ev, index) => {
      if (ev?.image) {
        evidences.push({
          type: 'image',
          src: ev.image,
          label: `${assignee.first_name} ${assignee.last_name} - Image${assigneeEvidences.length > 1 ? ` ${index + 1}` : ''}`,
        });
      }
      if (ev?.audio) {
        evidences.push({
          type: 'audio',
          src: ev.audio,
          label: `${assignee.first_name} ${assignee.last_name} - Audio${assigneeEvidences.length > 1 ? ` ${index + 1}` : ''}`,
        });
      }
    });
    return evidences;
  };

  // Generic gallery opener
  const openGallery = (items, startIndex = 0) => {
    setGalleryItems(items);
    setGalleryStartIndex(startIndex);
    setGalleryOpen(true);
  };

  // Handle assignee evidence click
  const handleAssigneeEvidenceClick = (assignee, evidenceSrc) => {
    const items = collectAssigneeEvidences(assignee);
    const index = items.findIndex(item => item.src === evidenceSrc);
    openGallery(items, index >= 0 ? index : 0);
  };

  // Close gallery and reset state
  const handleCloseGallery = () => {
    setGalleryOpen(false);
    setGalleryItems([]);
    setGalleryStartIndex(0);
  };

  const showMoreAssignee = index => {
    setMoreAssignee(true);
    setSelectedRow(index);
  };

  const toolTipChange = (value, index) => {
    setToolTip(value);
    setSelectIndex(index);
  };

  const visibilityChange = state => {
    setVisibility(state);
  };

  //function
  useOutsideClickHandler(moreRef1, moreRef2);
  function useOutsideClickHandler(moreRef1, moreRef2) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          moreRef1.current &&
          !moreRef1.current.contains(event.target) &&
          moreRef2.current &&
          !moreRef2.current.contains(event.target)
        ) {
          setMoreAssignee(false);
          visibilityChange(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [moreRef1, moreRef2, moreAssignee]);
  }

  const updateAssingeeList = (person, projectId, taskId) => {
    // if (
    //   selectedOrganization &&
    //   selectedOrganization.id &&
    //   projectId &&
    //   taskId &&
    //   person &&
    //   person.id
    // ) {
    //   const payload = {
    //     organization_id: selectedOrganization.id,
    //     project_id: projectId,
    //     task_id: taskId,
    //     user_id: person.id,
    //   };
    //   addTaskAssignee(payload);
    // }
  };

  const handleDeleteAssignee = (assigneeId, projectId, taskId) => {
    // if (
    //   selectedOrganization &&
    //   selectedOrganization.id &&
    //   projectId &&
    //   taskId &&
    //   assigneeId
    // ) {
    //   const payload = {
    //     organization_id: selectedOrganization.id,
    //     project_id: projectId,
    //     task_id: taskId,
    //     user_id: assigneeId,
    //   };
    //   deleteTaskAssignee(payload);
    // }
  };

  const handleExpandBudgetSection = taskId => {
    if (expandedTaskId && expandedTaskId === taskId) {
      setExpandedTaskId(null);
    } else {
      setExpandedTaskId(taskId);
    }
  };

  const { t, i18n } = useTranslation();

  // Dynamic paths and labels based on organization type (default to "operation" if not defined)
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  const detailsPath = isOperationType
    ? "/user/task-details"
    : "/user/job-details";
  const taskNameLabel = isOperationType ? t("task_name") : t("job_name");
  const noItemFoundLabel = isOperationType
    ? t("no_task_found")
    : t("no_job_found");

  // Get organization timezone for time display
  const orgTimezone = selectedOrganization?.timezone || moment.tz.guess();

  // Helper function to parse and format time in organization timezone
  const formatTimeInOrgTimezone = timeString =>
    formatTimeInTimezone(timeString, orgTimezone);

  return (
    <Container showBorder={true} style={{ paddingBottom: "20px" }}>
      <EvidenceGalleryModal
        isOpen={galleryOpen}
        items={galleryItems}
        startIndex={galleryStartIndex}
        onClose={handleCloseGallery}
      />
      {isLoading ? (
        <ComponentCircleLoader />
      ) : jobList && jobList.length > 0 ? (
        <>
          <ProjectTableContainerNew disableResponsive={true} active={true} heading>
            <TableItem>
              <TableText>{taskNameLabel}</TableText>
            </TableItem>

            {orgType === "service" && (
              <TableItem>
                <TableText>{t("customer")}</TableText>
              </TableItem>
            )}

            <TableItem>
              <TableText>{t("assignee")}</TableText>
            </TableItem>

            {taskStatus?.value !== "unscheduled" && (
              <TableItem>
                <TableText>{t("date_time")}</TableText>
              </TableItem>
            )}
            <TableItem>
              <TableText>{t("progress")}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t("status")}</TableText>
            </TableItem>

            {["completed", "all", "pending", "approved"].includes(
              taskStatus?.value,
            ) && (
              <TableItem centerAlign>
                <TableText>{t("approval")}</TableText>
              </TableItem>
            )}

            <TableItem>
              <TableText>{t("actions")}</TableText>
            </TableItem>
          </ProjectTableContainerNew>

          {jobList.map((task, index) => (
            <TableRowAndBudgetCollapseContainer key={task.id}>
              <ProjectTableContainerNew
                isLastItem={index === jobList.length - 1}
                active={expandedTaskId && expandedTaskId === task.id}
                disableResponsive={true}
              >
                {/* Job Name */}
                <TableItem
                  style={{
                    gridTemplateColumns: "auto auto",
                    alignItems: "center",
                    gridColumnGap: "10px",
                  }}
                >
                  <TableText
                    hoverPointer
                    hoverUnderline
                    wrap="normal"
                    align="left"
                    fontWeight="600"
                    color="#000E2A"
                    // fontWeight={
                    //   expandedTaskId && expandedTaskId === task.id && "600"
                    // }
                    onClick={() =>
                      history.push(
                        `${detailsPath}?id=${task.id}&${
                          orgType === "service" ? "job_id" : "task_id"
                        }=${task.work_order.id}`,
                      )
                    }
                  >
                    {task.name?.trim().replace(/\s+/g, " ")}
                  </TableText>
                </TableItem>

                {/* Customer Name */}
                {orgType === "service" && (
                  <TableItem
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      history.push(
                        `/user/customer-details?id=${task.work_order.client_id}`,
                      )
                    }
                  >
                    <TableText hoverPointer hoverUnderline name>
                      {task.work_order.client_name || "N/A"}
                    </TableText>
                  </TableItem>
                )}
                {/* <TableItem padding="10px 0 10px 10px">
                  {task.assignees &&
                  task.assignees.length > 0 &&
                  task.assignees[0].id ? (
                    <AssigneeRoundImg
                      image={task.assignees[0].avatar || avatar5}
                    >
                      <AssigneeTooltip
                        toolTipText={`${task.assignees[0].first_name}${
                          task.assignees[0].last_name
                            ? ` ${task.assignees[0].last_name}`
                            : ``
                        }`}
                        phone={task.assignees[0].phone}
                        top="-60px"
                        left="-55px"
                      />
                    </AssigneeRoundImg>
                  ) : null}
                </TableItem> */}
                <TableItem style={{ cursor: "pointer" }}>
                  <AssigneeRoundImageSection
                    position={task.assignees.length}
                    style={{ marginRight: `auto` }}
                  >
                    {task.assignees && task.assignees.length > 3 && (
                      <AssigneeRoundImage
                        index="more"
                        onClick={() => {
                          showMoreAssignee(index);
                          visibilityChange(true);
                        }}
                        ref={moreRef2}
                        style={{
                          border: `1px solid #fff`,
                          paddingLeft: "3px",
                        }}
                      >
                        {`+${task.assignees.length - 3}`}
                      </AssigneeRoundImage>
                    )}
                    <>
                      {task.assignees && task.assignees.length > 0 ? (
                        <>
                          {task.assignees
                            .filter((person, index) => index < 3)
                            .map((filteredPerson, index) => (
                              <AssigneeRoundImage
                                key={index}
                                index={
                                  task.assignees.length < 4
                                    ? index + 1
                                    : index + 2
                                }
                              >
                                <AssigneeTooltip
                                  toolTipText={`${filteredPerson.first_name} ${filteredPerson.last_name}`}
                                />

                                {filteredPerson.avatar ? (
                                  <RoundPersonImage
                                    src={
                                      filteredPerson.avatar
                                        ? filteredPerson.avatar
                                        : avatar5
                                    }
                                    alt=""
                                  />
                                ) : (
                                  <FirstRoundLetterComp
                                    text={`${filteredPerson.first_name} ${filteredPerson.last_name}`}
                                    backColor={index}
                                    color={filteredPerson.color}
                                  />
                                )}
                              </AssigneeRoundImage>
                            ))}
                          {moreAssignee && selectedRow === index && (
                            <ShowMoreAssigneeList ref={moreRef1}>
                              {task.assignees.map((member, index) => (
                                <Fragment key={index}>
                                  <AssigneeRoundImage index={0} size="30px">
                                    {member.avatar ? (
                                      <RoundPersonImage
                                        src={
                                          member.avatar
                                            ? member.avatar
                                            : avatar5
                                        }
                                        alt=""
                                        size="30px"
                                        borderColor="#c2cce1"
                                      />
                                    ) : (
                                      <FirstRoundLetterComp
                                        text={`${member.first_name} ${member.last_name}`}
                                        backColor={index}
                                        color={member.color}
                                      />
                                    )}
                                  </AssigneeRoundImage>
                                  <AssignListText>
                                    {member.first_name} {member.last_name}
                                  </AssignListText>
                                </Fragment>
                              ))}
                            </ShowMoreAssigneeList>
                          )}
                        </>
                      ) : (
                        <CommonText>-</CommonText>
                      )}
                    </>
                  </AssigneeRoundImageSection>
                </TableItem>

                {/* Date & Time */}
                {taskStatus?.value !== "unscheduled" && (
                  <TableItem>
                    <TableText fontWeight="600">
                      {globalDateFormat(task.start_time, orgTimezone)} <br></br>
                      <TableText name>
                        {task.is_anytime === true
                          ? t("anytime_of_the_day")
                          : moment(task.start_time + "Z")
                              .tz(orgTimezone)
                              .format("h:mm a") +
                            " - " +
                            moment(task.end_time + "Z")
                              .tz(orgTimezone)
                              .format("h:mm a")}
                      </TableText>
                    </TableText>
                  </TableItem>
                )}

                {/* Progress */}
                <TableItem>
                  <CircularProgress percent={task.percentage_complete || 0} />
                </TableItem>

                {/* Status */}
                <TableItem>
                  <StatusWithDot status={task.status} />
                </TableItem>

                {/* Approval */}
                {["completed", "all", "pending", "approved"].includes(
                  taskStatus.value,
                ) && (
                  <TableItem centerAlign>
                    {(task.status === "completed" ||
                      task.status === "partially complete") &&
                    task.approval &&
                    task.approval.status ? (
                      // <ApprovalBadge status={task.approval.status}>
                      //   {t(task.approval.status)}
                      // </ApprovalBadge>
                      <Status status={task.approval.status} showDot={true} />
                    ) : (
                      <TableText name>-</TableText>
                    )}
                  </TableItem>
                )}
                <TableItem>
                  {selectedOrganization &&
                  selectedOrganization.role &&
                  (selectedOrganization.role === "admin" ||
                    selectedOrganization.role === "owner") ? (
                    <CommonFlexIcon gap="0px">
                      {/* Preview - Always shown for owner/admin */}
                      <IconButtonHolder
                        onClick={() => {
                          history.push(
                            `${detailsPath}?id=${task.id}&${
                              orgType === "service" ? "job_id" : "task_id"
                            }=${task.work_order.id}`,
                          );
                        }}
                      >
                        <CommonImage
                          src={
                            expandedTaskId && expandedTaskId === task.id
                              ? previewIconWhite
                              : previewIconNormal
                          }
                          alt=""
                          size="24px"
                        />
                        <TaskActionTooltip toolTipText={t(orgType === "service" ? "preview_job" : "preview_task")} />
                      </IconButtonHolder>

                      {/* Edit - with status and time condition checks */}
                      {task.status &&
                        (task.status === "unscheduled" ||
                          isReadyToDispatchStatus(task.status) ||
                          task.status === "totally missed") &&
                        (task.is_anytime === true ||
                          (task.start_time &&
                            (() => {
                              // Parse start_time the same way as formatTimeInOrgTimezone
                              const hasTimezone = /[+-]\d{2}:?\d{2}$/.test(
                                task.start_time,
                              );
                              const startTimeMoment = hasTimezone
                                ? moment(task.start_time)
                                : moment.utc(task.start_time);
                              return (
                                startTimeMoment.tz(orgTimezone).unix() >=
                                moment().tz(orgTimezone).unix()
                              );
                            })())) && (
                          <IconButtonHolder
                            onClick={() => {
                              setIsEditJobPopupOpen(true);
                              setSelectedJob(task);
                            }}
                          >
                            <CommonImage
                              src={
                                expandedTaskId && expandedTaskId === task.id
                                  ? editIconWhite
                                  : editIconNormal
                              }
                              alt=""
                              size="24px"
                            />
                            <TaskActionTooltip toolTipText={t(orgType === "service" ? "edit_job" : "edit_task")} />
                          </IconButtonHolder>
                        )}

                      {/* Delete - with status condition check */}
                      {task.status &&
                        task.status !== "in_progress" && (
                          <IconButtonHolder
                            onClick={() =>
                              toggleDeleteModal(task.id, task.work_order.id)
                            }
                          >
                            <CommonImage
                              src={
                                expandedTaskId && expandedTaskId === task.id
                                  ? deleteIconWhite
                                  : deleteIconNormal
                              }
                              alt=""
                              size="24px"
                            />
                            <TaskActionTooltip toolTipText={t(orgType === "service" ? "delete_job" : "delete_task")} />
                          </IconButtonHolder>
                        )}
                      {/* <CommonFlexIcon gap="0px">
                      </CommonFlexIcon> */}
                      {/* Expand - only if not unscheduled */}
                      {task.status !== "unscheduled" && (
                        <IconButtonHolder
                          onClick={() => handleExpandBudgetSection(task.id)}
                        >
                          <CommonImage
                            src={
                              expandedTaskId && expandedTaskId === task.id
                                ? expandIconWhite
                                : expandIconNormal
                            }
                            alt="expand"
                            size="24px"
                            style={{
                              transform:
                                expandedTaskId && expandedTaskId === task.id
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                              transition: "transform 0.4s ease",
                              transformOrigin: "center",
                            }}
                          />
                          <TaskActionTooltip
                            toolTipText={
                              expandedTaskId && expandedTaskId === task.id
                                ? orgType === "operation"
                                  ? t("collapse_task")
                                  : t("collapse_job")
                                : orgType === "operation"
                                ? t("expand_task")
                                : t("expand_job")
                            }
                          />
                        </IconButtonHolder>
                      )}
                    </CommonFlexIcon>
                  ) : (
                    <div />
                  )}
                </TableItem>
                {/* Expansion Section start */}
                {/* <TableItem>
                  {task.status === "unscheduled" ? (
                    ""
                  ) : (
                    <CommonFlex
                      gap="2px"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <ProjectExpandButton
                        onClick={() => handleExpandBudgetSection(task.id)}
                      >
                        <ExpandIcon
                          src={arrowWhiteIcon}
                          alt=""
                          open={expandedTaskId && expandedTaskId === task.id}
                        />
                      </ProjectExpandButton>
                    </CommonFlex>
                  )}
                </TableItem> */}
              </ProjectTableContainerNew>
              {/* <HorizontalLineDivider /> */}
              {/* Expansion Section end */}
              <CollapseSection
                open={expandedTaskId && expandedTaskId === task.id}
                active={expandedTaskId && expandedTaskId === task.id}
              >
                <JobListCollapseSection
                  task={task}
                  orgTimezone={orgTimezone}
                  handleAssigneeEvidenceClick={handleAssigneeEvidenceClick}
                  toolTipChange={toolTipChange}
                  selectIndex={selectIndex}
                  toolTip={toolTip}
                  isOperationType={isOperationType}
                />
              </CollapseSection>
            </TableRowAndBudgetCollapseContainer>
          ))}
        </>
      ) : (
        <NoDataComponent title={noItemFoundLabel} />
      )}
    </Container>
  );
};

export default JobList;
